import { render, staticRenderFns } from "./MetaSection.vue?vue&type=template&id=279753ad&scoped=true&"
import script from "./MetaSection.vue?vue&type=script&lang=ts&"
export * from "./MetaSection.vue?vue&type=script&lang=ts&"
import style0 from "./MetaSection.vue?vue&type=style&index=0&id=279753ad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279753ad",
  null
  
)

export default component.exports